import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;

@Component({
  selector: 'app-white-paper',
  templateUrl: './white-paper.component.html',
  styleUrls: ['./white-paper.component.scss']
})
export class WhitePaperComponent implements OnInit, AfterViewInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService

  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function(){});
      // $.getScript('../../../assets/js/owl.carousel.min.js', function(){});
      $.getScript('../../../../node_modules/slick-carousel/slick/slick.min.js', function () { });
      $.getScript('../../../assets/js/WhitePaper.js', function () { });
    }
    this.titleService.setTitle('[Whitepaper] Comparando a Trinka com Grammarly Language Tool para Textos Acadêmicos');
    this.metaTagService.updateTag({ name: 'description', content: 'Baixe nosso whitepaper exclusivo para entender como a Trinka se compara com Grammarly Premium e Language Tool para textos acadêmicos.' });
    this.metaTagService.updateTag({ property: 'og:title', content: '[Whitepaper] Comparando a Trinka com Grammarly Language Tool para Textos Acadêmicos' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Baixe nosso whitepaper exclusivo para entender como a Trinka se compara com Grammarly Premium e Language Tool para textos acadêmicos.' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/trinka-vs-grammarly-vs-language-tool' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'pt-pt' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/pt/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinka-vs-grammarly-vs-language-tool'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinka-vs-grammarly-vs-language-tool'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinka-vs-grammarly-vs-language-tool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinka-vs-grammarly-vs-language-tool' });

    ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()})
  }
  ngAfterViewInit() {

  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
